module.exports = __webpack_public_path__ + "img/Ellipse14.1be2350b.png";